import { http, HttpResponse } from "msw";
import { apiPaths } from "../../api-paths.js";
import type { Locations_FindClientLocationQueryResponse_Success } from "../../swagger-types/v1/index.js";

const userLocation: Locations_FindClientLocationQueryResponse_Success = {
  location: {
    countryCode: "PL",
    stateCode: "06",
    city: "Lubartów",
    postalCode: "21-100",
    currencyCode: "PLN",
    languageCode: null,
    latitude: 51.465,
    longitude: 22.6081,
    timezone: "Europe/Warsaw",
    isp: "Interduo Bujek Klopotek Sowa Spolka Jawna",
    org: "Interduo Bujek Klopotek Sowa Spolka Jawna",
  },
};

const germanUserLocation: Locations_FindClientLocationQueryResponse_Success = {
  location: {
    countryCode: "DE",
    stateCode: "BE",
    city: "Berlin",
    postalCode: "10178",
    currencyCode: "EUR",
    languageCode: null,
    latitude: 52.520008,
    longitude: 13.404954,
    timezone: "Europe/Berlin",
    isp: "Interduo Bujek Klopotek Sowa Spolka Jawna",
    org: "Interduo Bujek Klopotek Sowa Spolka Jawna",
  },
};

const canadaUserLocation: Locations_FindClientLocationQueryResponse_Success = {
  location: {
    countryCode: "CA",
    stateCode: "QC",
    city: "Montreal",
    postalCode: "H3H",
    currencyCode: "CAD",
    latitude: 45.5088,
    longitude: -73.5878,
    timezone: "America/Toronto",
    isp: "M247 Europe SRL",
    org: "M247 LTD",
    languageCode: "EN",
  },
};

export const getUserLocationHandlers = {
  getUserLocation: [
    http.get(`*${apiPaths.geolocation.get}*`, () => {
      return HttpResponse.json(userLocation, { status: 200 });
    }),
  ],
};

export const getGermanUserLocationHandlers = {
  getUserLocation: [
    http.get(`*${apiPaths.geolocation.get}*`, () => {
      return HttpResponse.json(germanUserLocation, { status: 200 });
    }),
  ],
};

export const getCanadaUserLocationHandlers = {
  getUserLocation: [
    http.get(`*${apiPaths.geolocation.get}*`, () => {
      return HttpResponse.json(canadaUserLocation, { status: 200 });
    }),
  ],
};
